import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { UploadFile } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';
import DeleteIcon from '../images/delete.png';

export class TroubleTicketActionItemForm extends Component {
  static displayName = TroubleTicketActionItemForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      model: props.model,
      alert: props.alert || { color: '', message: '', isOpen: false },
      deltaPosition: { x: 0, y: 0 },
    };

    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleDeleteFile = this.handleDeleteFile.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownHandler, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler, true);
  }

  keydownHandler = (e) => {
    if (e.altKey && e.keyCode === 83) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.onSave();
    }
  };

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;
    this.setState({ model });
  }

  handleUploadFile(e) {
    let model = { ...this.state.model };
    model.FileName = e.target.files[0].name;
    model.FormFile = e.target.files[0];
    this.setState({ model });
  }

  handleDeleteFile() {
    this.fileUpload.value = null;
    let model = { ...this.state.model };
    model.FileName = '';
    model.FileLocationS3 = '';
    model.FormFile = null;
    this.setState({ model });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  onDelete() {
    if (!window.confirm('Are you sure you want to delete this attachment?')) return;

    const model = this.state.model;
    const formData = new FormData();
    formData.append('EventType', 'delete');
    formData.append('TroubleTicketActionItemId', model.TroubleTicketActionItemId || '');
    formData.append('UpdateByUserId', this.user.userid || '');

    UploadFile('/savetroubleticketactionitem', this.user.token, formData).then(
      (data) => {
        const rawMessage =
          data && typeof data === 'object' && data.message ? data.message : data;
        const message = String(rawMessage || '').trim().replace(/^"+|"+$/g, '');
        const isSuccess = /\bsuccess\b/i.test(message);

        if (isSuccess) {
          this.props.handleSaveEventSuccess({ message, color: 'success' });
        } else {
          this.handleSaveEventSuccess({ message: message || 'Unknown response', color: 'warning' });
        }
      }
    );
  }

  async onSave() {
    let model = this.state.model;

    if (model.EventType === 'insert') {
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === 'update') {
      model.UpdateByUserId = this.user.userid;
    }

    var formData = new FormData();
    formData.append('EventType', model.EventType);
    formData.append(
      'TroubleTicketActionItemId',
      model.TroubleTicketActionItemId || ''
    );
    formData.append(
      'TroubleTicketActionId',
      model.TroubleTicketActionId || ''
    );
    formData.append(
      'TroubleTicketActionItemDescription',
      model.TroubleTicketActionItemDescription || ''
    );
    formData.append('FileLocationS3', model.FileLocationS3 || '');
    formData.append('FileName', model.FileName || '');
    formData.append('CreateByUserId', model.CreateByUserId || '');
    formData.append('UpdateByUserId', model.UpdateByUserId || '');
    if (model.FormFile) {
      formData.append('FormFile', model.FormFile);
    }

    UploadFile('/savetroubleticketactionitem', this.user.token, formData).then(
      (data) => {
        const rawMessage =
          data && typeof data === 'object' && data.message
            ? data.message
            : data;
        const message = String(rawMessage || '')
          .trim()
          .replace(/^"+|"+$/g, '');
        const isSuccess = /\bsuccess\b/i.test(message);

        if (isSuccess) {
          this.props.handleSaveEventSuccess({
            message: message,
            color: 'success',
          });
        } else {
          this.handleSaveEventSuccess({
            message: message || 'Unknown response',
            color: 'warning',
          });
        }
      }
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const m = this.state.model;

    return (
      <Draggable
        handle=".action-item-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '500px',
              maxWidth: '500px',
            }}
            backdrop="static"
          >
            <ModalHeader className="action-item-handle handle">
              {m.EventType === 'insert'
                ? 'New Attachment'
                : 'Edit Attachment'}
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                      style={{ textAlign: 'center' }}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '90px' }}>
                        Description:
                      </InputGroupText>
                      <textarea
                        name="TroubleTicketActionItemDescription"
                        rows="3"
                        className="form-control form-control-text"
                        value={m.TroubleTicketActionItemDescription || ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <hr />
                <Row>
                  <Col
                    className={m.FileName === '' ? 'col-12' : 'col-11'}
                  >
                    <div style={{ position: 'relative', height: '100px' }}>
                      <input
                        id="action-item-file"
                        type="file"
                        name="fileUpload"
                        onChange={this.handleUploadFile}
                        ref={(ref) => (this.fileUpload = ref)}
                        style={{
                          position: 'absolute',
                          inset: 0,
                          opacity: 0,
                          width: '100%',
                          height: '100%',
                          cursor: 'pointer',
                          zIndex: 2,
                        }}
                      />
                      <label
                        htmlFor="action-item-file"
                        className="form-control d-flex align-items-center justify-content-center"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          border: '1px dashed #ccc',
                          borderRadius: '20px',
                          margin: 0,
                          textAlign: 'center',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          padding: '0 12px',
                        }}
                      >
                        {m.FileName === '' || !m.FileName
                          ? 'Drag your file here!'
                          : m.FileName}
                      </label>
                    </div>
                  </Col>
                  {m.FileName && m.FileName !== '' && (
                    <Col className="col-1">
                      <img
                        src={DeleteIcon}
                        style={{
                          width: '14px',
                          height: '14px',
                          cursor: 'pointer',
                        }}
                        onClick={this.handleDeleteFile}
                        alt="Delete"
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </ModalBody>
            <ModalFooter />
          </Modal>
        </div>
      </Draggable>
    );
  }
}
